import type { ComputedRef, Ref } from 'vue'
import type { ConnectionSlot } from '@/types'

/**
 * Builder-wide connection authoring context (ADR-030, model D), provided by the editing host
 * (BuilderView) and injected by the connection picker. Absent in read-only contexts (run-history
 * replay) — the picker then shows the assigned connection without create/delete affordances.
 */
export interface BuilderConnectionContext {
  /** The workflow being edited — drives the slot CRUD mutations. */
  workflowId: Ref<string>
  /** The workflow's defined connection slots, reactive to slot create/delete. */
  connectionSlots: ComputedRef<ConnectionSlot[]>
}

/** provide/inject key for {@link BuilderConnectionContext}. */
export const CONNECTION_CONTEXT_KEY = 'builderConnectionContext'
